import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { StorageFile } from "../../../types/StorageFile";
import { array, enumValues, nullable, string, timestamp } from "../../../types/_types";

import { OrganizationRef } from "../../organizations/types/OrganizationRef";

import cloudRevenueStatuses from "../constants/cloudRevenueStatuses";

import { WorkMetaData } from "./WorkMetaData";

export const Work = WorkMetaData.extend({
	publisher: OrganizationRef,
	coverThumb: nullable(StorageFile),
	cloudRevenueStatus: nullable(enumValues(cloudRevenueStatuses)),
	// When it first went live, or when a prepaid period ends. Works without it are never billed.
	billableFrom: nullable(timestamp()),
	// Start fee price types already charged.
	startFees: array(string()),
})
	.merge(FirestoreDocument)
	.merge(FirestoreLifecycle);
